import { SettingsPaths } from "Pages/settings/paths";

import EventManagementRouter from "./EventManagementRouter";
import EventDefinitionForm from "./Pages/EventDefinitionForm/EventDefinitionForm";
import EventDefinitionsGridPage from "./Pages/EventDefinitionsGridPage/EventDefinitionsGridPage";
import { EventManagementPaths } from "./paths";

import type { RegalRouteObject } from "App/routes/types";

export const eventManagementRoute: RegalRouteObject = {
    path: `${SettingsPaths.eventManagement}/*`,
    element: <EventManagementRouter />,
    hasNestedRoutes: true,
    children: [
        {
            index: true,
            element: <EventDefinitionsGridPage />,
        },
        {
            path: EventManagementPaths.eventForm,
            element: <EventDefinitionForm />,
        },
    ],
};
